export default {
  addDetailsLink: {
    id: 'asp_action_bar_declare_problem_upload_step_add_details_link',
    defaultMessage: 'Add details for the agent',
  },
  submitButton: {
    id: 'asp_action_bar_declare_problem_upload_step_send_button',
    defaultMessage: 'Send to agent',
  },
  textareaLabel: {
    id: 'asp_action_bar_declare_problem_upload_step_textarea_label',
    defaultMessage: 'Add a message',
  },
  optional: {
    id: 'asp_action_bar_declare_problem_upload_step_optional',
    defaultMessage: '(optional)',
  },
  requiredMessageError: {
    id: 'asp_action_bar_declare_problem_upload_step_required_error_message',
    defaultMessage: 'This field is required',
  },
  fileInputMaxSizeError: {
    id: 'asp_action_bar_declare_problem_upload_step_max_size_error_message',
    defaultMessage: 'Oops, the maximum files size should not exceed 10MB',
  },
  checkboxLabel: {
    id: 'asp_seller_action_bar_next_task_checkbox',
    defaultMessage: 'Go to the next task after confirming your action.',
  },
}
